/*
 * View for the right side of the Topic page.  If the topic is a FAQ, it shows the response
 * preview.  If it is a conversation, it shows a read-only topic diagram
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/topicsSplit/topic/topicConversationPreview/topicConversationPreviewView",
  "modules/topicsSplit/topic/topicDiagramArea/topicDiagramAreaModule",
  "modules/topicsSplit/topic/topicResponse/topicResponseModule",
], function (
  Marionette,
  Messenger,
  TopicConversationPreviewView,
  TopicDiagramAreaModule,
  TopicResponseModule,
) {
  var TopicConversationPreviewController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "topicConversationPreview";
      this.region = options.region;
      this._setUpVents();
    },
    show: function (conversation, liveConversationRoot) {
      this.conversation = conversation;
      this.layout = new TopicConversationPreviewView.topicConversationPreviewLayout();
      //wait to set sub-modules until the conversation is loaded
      this.layout.on(
        "show",
        function () {
          this._showSubViews(conversation, liveConversationRoot);
        },
        this,
      );
      this.showRegion(this.layout, { loading: true, entity: conversation });
    },
    _decideSubViews: function (conversation, liveConversationRoot) {
      if (!conversation.decisionCol || conversation.decisionCol.length === 0) {
        this.response = this.addSubModule(
          new TopicResponseModule({ region: this.layout.previewArea }),
        );
        this.response.show(conversation, liveConversationRoot);
      } else {
        //make READ ONLY diagram
        this.diagram = this.addSubModule(
          new TopicDiagramAreaModule({ region: this.layout.previewArea, readOnly: true }),
        );
        this.diagram.show(conversation);
      }
    },
    _showSubViews: function (conversation, liveConversationRoot) {
      //decide which sub module to show
      conversation.onSynced(() => this._decideSubViews(conversation, liveConversationRoot));
    },
    _setUpVents: function () {
      //when changing from a FAQ to a branching conversation, re-render the preview
      Messenger.vent.on(
        "conversation:created",
        function () {
          this.show(this.conversation);
        },
        this,
      );
    },
  });

  return TopicConversationPreviewController;
});
